import { ChevronRightIcon } from "@heroicons/react/24/outline";
import React from "react";

import { GoalsFilterSubPanel } from "@pages/ClinicalReportDetails/ReportPage/Components/GoalsFilterSubPanel";

interface FilterCategory {
  key: string;
  label: string;
  options: { id: string; label: string }[];
}

interface GoalsFilterCategoryRowProps {
  category: FilterCategory;
  isActive: boolean;
  selected: string[];
  onToggleActive: () => void;
  onToggle: (id: string) => void;
  onClear: () => void;
}

export const GoalsFilterCategoryRow: React.FC<GoalsFilterCategoryRowProps> = ({
  category,
  isActive,
  selected,
  onToggleActive,
  onToggle,
  onClear,
}) => (
  <div className="relative px-2 py-1">
    <button
      className={`flex w-full flex-1 items-center justify-between rounded-sm p-1 hover:bg-limestone-50 ${isActive ? "bg-limestone-50" : ""}`}
      onClick={onToggleActive}
    >
      <span className="text-sm font-normal leading-[22px] text-limestone-900">{category.label}</span>
      <div className="flex items-center gap-1">
        {selected.length > 0 && (
          <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-green-100 px-1.5 text-xs font-semibold text-green-700">
            {selected.length}
          </span>
        )}
        <ChevronRightIcon className="h-4 w-4 text-limestone-600" />
      </div>
    </button>
    {isActive && (
      <GoalsFilterSubPanel options={category.options} selected={selected} onToggle={onToggle} onClear={onClear} />
    )}
  </div>
);
